/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_SculptureInputs */

const en_val_sculpture = /** @type {(inputs: Val_SculptureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sculpture`)
};

const es_val_sculpture = /** @type {(inputs: Val_SculptureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escultura`)
};

const fr_val_sculpture = /** @type {(inputs: Val_SculptureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sculpture`)
};

const de_val_sculpture = /** @type {(inputs: Val_SculptureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skulptur`)
};

const ja_val_sculpture = /** @type {(inputs: Val_SculptureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`彫刻`)
};

const zh_val_sculpture = /** @type {(inputs: Val_SculptureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`雕塑`)
};

const ar_val_sculpture = /** @type {(inputs: Val_SculptureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`منحوتة`)
};

const id_val_sculpture = /** @type {(inputs: Val_SculptureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patung`)
};

const it_val_sculpture = /** @type {(inputs: Val_SculptureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scultura`)
};

const ru_val_sculpture = /** @type {(inputs: Val_SculptureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Скульптура`)
};

const pt_val_sculpture = /** @type {(inputs: Val_SculptureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escultura`)
};

const ko_val_sculpture = /** @type {(inputs: Val_SculptureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`조각`)
};

/**
* | output |
* | --- |
* | "Sculpture" |
*
* @param {Val_SculptureInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_sculpture = /** @type {((inputs?: Val_SculptureInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_SculptureInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_sculpture(inputs)
	if (locale === "es") return es_val_sculpture(inputs)
	if (locale === "fr") return fr_val_sculpture(inputs)
	if (locale === "de") return de_val_sculpture(inputs)
	if (locale === "ja") return ja_val_sculpture(inputs)
	if (locale === "zh") return zh_val_sculpture(inputs)
	if (locale === "ar") return ar_val_sculpture(inputs)
	if (locale === "id") return id_val_sculpture(inputs)
	if (locale === "it") return it_val_sculpture(inputs)
	if (locale === "ru") return ru_val_sculpture(inputs)
	if (locale === "pt") return pt_val_sculpture(inputs)
	return ko_val_sculpture(inputs)
});